import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { BookOpenIcon, ListChecksIcon, BrainIcon, LayersIcon, CalendarIcon, CreditCardIcon, ClipboardListIcon } from 'lucide-react';
export function WhatYouGetSection() {
  return <SectionWrapper data-id="element-456">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-12" variants={childVariants} data-id="element-457">
        What you get instantly
      </motion.h2>

      <motion.p className="font-heading text-lg text-teal-light mb-8" variants={childVariants} data-id="element-458">
        The 3AM Reset ebook (PDF) including:
      </motion.p>

      <motion.ul className="space-y-6 mb-14" variants={childVariants} data-id="element-459">
        <li className="flex items-start gap-4" data-id="element-460">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-461">
            <BookOpenIcon className="w-4 h-4 text-teal-light" data-id="element-462" />
          </div>
          <div data-id="element-463">
            <p className="font-body text-lg text-cream font-medium" data-id="element-464">
              Quick Start page for the moment you wake up
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-465">
              The 90-Second Rule
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-466">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-467">
            <LayersIcon className="w-4 h-4 text-teal-light" data-id="element-468" />
          </div>
          <div data-id="element-469">
            <p className="font-body text-lg text-cream font-medium" data-id="element-470">
              3 "Body Downshift" options
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-471">
              Pick one and lock it in
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-472">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-473">
            <BrainIcon className="w-4 h-4 text-teal-light" data-id="element-474" />
          </div>
          <div data-id="element-475">
            <p className="font-body text-lg text-cream font-medium" data-id="element-476">
              The Brain Off‑Ramp scripts
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-477">
              So you're not improvising at 3am
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-478">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-479">
            <ListChecksIcon className="w-4 h-4 text-teal-light" data-id="element-480" />
          </div>
          <div data-id="element-481">
            <p className="font-body text-lg text-cream font-medium" data-id="element-482">
              The Return-to-Sleep Ladder
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-483">
              A no-bargaining sequence
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-484">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-485">
            <CalendarIcon className="w-4 h-4 text-teal-light" data-id="element-486" />
          </div>
          <div data-id="element-487">
            <p className="font-body text-lg text-cream font-medium" data-id="element-488">
              A full 14-Night Reset Plan
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-489">
              Track progress without obsessing
            </p>
          </div>
        </li>
      </motion.ul>

      {/* Bonuses */}
      
    </SectionWrapper>;
}